<script lang="ts">
    import { Button, Col, Form, Input, Label, Row } from "sveltestrap";
    import { Cancel, Email, Name, Phone, Save } from "../../../utils/Constant/Constant";
    import {editForm,personalContact,personalData} from "../../../store"
    let setPersonalData:any
    personalData.subscribe((value)=>{
        setPersonalData = value
    })
    export let getId:number
    let setEditForm:boolean
    editForm.subscribe((value) => {
      setEditForm = value
    })
    let newFname:string = setPersonalData[getId].fname
    let newLname:string = setPersonalData[getId].lname
    let newPhone:number = setPersonalData[getId].phone
    let newEmail:string = setPersonalData[getId].email
    const toggle = (e:any) =>{
      e.preventDefault()
      (editForm.update(value => value = !value))
    }
    let setPersonalContact:number
    personalContact.subscribe((value)=>{
        setPersonalContact = value
    })
    const handleEditContact = (e:any) => {
      e.preventDefault()
      let editData = {
        fname : newFname,
        lname : newLname,
        phone : newPhone,
        email : newEmail,
      }
      personalData.update(value => value = setPersonalData.map((data:any,index:number)=> index == getId ? editData : data )  )
      newFname = "", newLname = "", newPhone = null, newEmail = ""
      editForm.update(value => value = !value)
    }
</script>
<div class="contact-editform ps-0 {getId == setPersonalContact && setEditForm ? "d-block" : "d-none"}">
  <Form>
    <Row class="g-2">
      <Col md="12" class="mt-0 mb-3">
        <Label>{Name}</Label>
        <Row>
          <Col sm="6">
            <Input id="first_name" type="text" required placeholder="First Name" bind:value={newFname} />
          </Col>
          <Col sm="6" >   
            <Input id="last_name" type="text" required placeholder="Last Name" bind:value={newLname} />
          </Col>
        </Row>
      </Col>
      <Col md="12" class="mt-0 mb-3">
        <Label>{Email}</Label>
        <Input id="mobile_num" type="email" required autocomplete="off" bind:value={newEmail}/>
      </Col>
      <Col md="12" class="mt-0 mb-3">
        <Label>{Phone}</Label>
        <Input id="mobile_num" type="number" required bind:value={newPhone} />
      </Col>
    </Row>
    <Button color="secondary" class="update-contact" on:click={(event)=>handleEditContact(event)}>{Save}</Button>
    <Button color="primary" on:click={toggle}>{Cancel}</Button>
  </Form>
</div>